// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"337":"dc2fbed4","492":"01c2d60f"}[chunkId] + ".chunk.css";
};